import { Module } from '@nestjs/common';
import { MongooseModule } from '@nestjs/mongoose';
import { CountryController } from './controllers/country.controller';
import { StateController } from './controllers/state.controller';
import { CountryService } from './services/country.service';
import { StateService } from './services/state.service';
import { Country, CountrySchema } from './schemas/country.schema';
import { State, StateSchema } from './schemas/state.schema';

@Module({
  imports: [
    MongooseModule.forFeature([
      { name: Country.name, schema: CountrySchema },
      { name: State.name, schema: StateSchema },
    ]),
  ],
  controllers: [CountryController, StateController],
  providers: [CountryService, StateService],
  exports: [CountryService, StateService],
})
export class LocationModule {}